import { Button } from 'antd';
import styled from 'styled-components';

export const ModalContainer = styled.div``;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-height: 570px;

  h1 {
    margin-top: 20px;
    font-size: 2rem;
    font-weight: 600;
    color: ${({ theme }) => theme.purple};
  }

  img {
    width: 200px;
    height: 200px;
    margin-bottom: 12px;
  }

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: scroll;
    height: 100%;
    width: 100%;
  }

  @media (max-width: 1600px) {
    max-height: 580px;
  }
`;

export const CustomButton = styled(Button)`
  background: ${({ theme }) => theme.purple};
  height: 50px;
  border: 0;
  width: 100%;
  font-size: 1.5rem;
  transition: filter 0.2s;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.purple};
    filter: brightness(0.9);
  }

  &:hover:disabled {
    background: ${({ theme }) => theme.purple};
    color: #fff;
  }

  &:disabled {
    background: ${({ theme }) => theme.purple};
    color: #fff;
  }
`;

export const FooterContainer = styled.footer`
  input {
    width: 97%;
    margin-bottom: 8px;
    font-size: 1.15rem;
  }
`;

export const EmptyCommentsCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    font-size: 1.5rem;
    margin-bottom: 0;
  }
`;
